import { useParams } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export default function Unsubscribe() {
  useSeo({ title: "Unsubscribe", noindex: true });
  const { id } = useParams();
  const { data, isLoading, isError } = useQuery({ queryKey: ["unsub", id], queryFn: () => api.unsubscribe(id), retry: false });
  return (
    <main className="app-main"><div className="wrap narrow" data-testid="unsubscribe-page">
      {isLoading && <p>One moment…</p>}
      {isError && <><h1>Link not recognised</h1><p className="lede">This unsubscribe link is not valid. Email <a href="mailto:hello@99tests.com">hello@99tests.com</a> and we will remove you by hand.</p></>}
      {data?.ok && <><span className="pill neutral">Unsubscribed</span><h1 style={{ marginTop: 12 }}>You won't hear from us again.</h1>
        <p className="lede">We've removed you from 99tests session offers and reactivation emails. Changed your mind? <a href="/join">Rejoin here</a>.</p></>}
    </div></main>
  );
}
